import createIcon from '../../createIcon';

/**
 * @component @name CellWifi
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS4wMzQ4NCAyMS41MDFIMjEuMDM0OFY1LjQ3MTA0TDUuMDM0ODQgMjEuNTAxWk0xOS4wMzQ4IDE5LjUwMUgxNy4wMzQ4VjEyLjI4MUwxOS4wMzQ4IDEwLjI4MVYxOS41MDFaTTQuMjU0ODQgNi43MjEwNEwyLjk2NDg0IDUuNDMxMDRDNi44NjQ4NCAxLjUyMTA0IDEzLjIwNDggMS41MjEwNCAxNy4xMTQ4IDUuNDMxMDRMMTUuODI0OCA2LjcyMTA0QzEyLjYzNDggMy41MzEwMyA3LjQ0NDg0IDMuNTMxMDMgNC4yNTQ4NCA2LjcyMTA0Wk0xMS45NjQ4IDEwLjU3MUwxMC4wMzQ4IDEyLjUwMUw4LjEwNDg0IDEwLjU3MUM5LjE3NDg0IDkuNTExMDQgMTAuODk0OCA5LjUxMTA0IDExLjk2NDggMTAuNTcxWk0xMy4yNTQ4IDkuMjkxMDRDMTEuNDc0OCA3LjUyMTA0IDguNTk0ODQgNy41MjEwNCA2LjgyNDg0IDkuMjkxMDRMNS41MzQ4NCA4LjAwMTA0QzguMDE0ODQgNS41MjEwNCAxMi4wNTQ4IDUuNTIxMDQgMTQuNTM0OCA4LjAwMTA0TDEzLjI1NDggOS4yOTEwNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CellWifi = createIcon('CellWifi', [
  [
    'path',
    {
      d: 'M5.03484 21.501H21.0348V5.47104L5.03484 21.501ZM19.0348 19.501H17.0348V12.281L19.0348 10.281V19.501ZM4.25484 6.72104L2.96484 5.43104C6.86484 1.52104 13.2048 1.52104 17.1148 5.43104L15.8248 6.72104C12.6348 3.53103 7.44484 3.53103 4.25484 6.72104ZM11.9648 10.571L10.0348 12.501L8.10484 10.571C9.17484 9.51104 10.8948 9.51104 11.9648 10.571ZM13.2548 9.29104C11.4748 7.52104 8.59484 7.52104 6.82484 9.29104L5.53484 8.00104C8.01484 5.52104 12.0548 5.52104 14.5348 8.00104L13.2548 9.29104Z',
      key: '1veqll',
    },
  ],
]);

export default CellWifi;
